import * as React from "react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../redux/reducer/rootReducer";
import { signalRStart } from "../redux/middleware/storeMiddleware";
import { AppLeftMenu } from "./AppLeftMenu";
import { AppTopbar } from "./AppTopbar";
import { isTokenValid } from "../services/utilities/utility";
import { useDispatch } from "react-redux";
import { getTeamSupportWidgetSnippet } from "../compenents/Dashboard/teamSupportWidget";
import { setIsSyncCompleted } from "../redux/reducer/features/Integration/DmsSetupSlice";
import SnackBarPopup from "../compenents/app/SnackBarPopup";
import { AppRoutes } from "./AppRoutes";

export interface AuthLayoutProps {}

const Main = styled("main")(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: "#f9f9f9",
  minHeight: "calc(100vh)",
  padding: theme.spacing(3),
  marginLeft: "60px",
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export const AuthLayout: React.FunctionComponent<AuthLayoutProps> = () => {
  const { token, targetWebAccessToken, name, dmsDealerId, email } = useSelector(
    (state: AppState) => state.authReducer
  );
  const setupId = useSelector((state: AppState) => state.authReducer.setupId);
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const isSyncCompleted = useSelector(
    (state: AppState) => state.dmsReducer.IsSyncCompleted
  );
  const [dmsType, setDmsType] = React.useState<number | undefined>(undefined);
  const [showSyncAlert, setShowSyncAlert] = React.useState(false);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  React.useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      if (setupId) signalRStart([setupId, dmsDealerId ?? ""], () => {});
      else signalRStart([dmsDealerId ?? ""], () => {});
    }
  }, [token, setupId]);

  if (!isTokenValid(targetWebAccessToken ?? "", dispatch)) {
    navigate("/login");
  }
  React.useEffect(() => {
    if (dmsSetup && dmsSetup.dmsLocations.length > 0) {
      setDmsType(dmsSetup.dmsLocations[0].dmsType);
    }
  }, [dmsSetup]);
  React.useEffect(() => {
    if (token && setupId) {
      window.beamer_config = {
        product_id: "NnPOXRbm71498",
        selector: ".beamerTrigger",
        button: false,
        user_id: dmsDealerId,
        user_firstname: name,
        user_lastname: ".",
        user_email: email,
      };
      const script = document.createElement("script");
      script.src = "https://app.getbeamer.com/js/beamer-embed.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [token, setupId]);

  React.useEffect(() => {
    if (setupId && isSyncCompleted) {
      setShowSyncAlert(true);
    }
  }, [isSyncCompleted]);

  //Team Support widget implementation
  React.useEffect(() => {
    let interval: any = undefined;

    //Only show the team support widget for Ideal DMS
    let teamSupportWidget = document.getElementById(
      "designstudio-button"
    ) as HTMLElement;
    if (teamSupportWidget) {
      //Again show back the team support
      teamSupportWidget.style.display = "unset";
      let teamSupportBody = document.getElementById(
        "designstudio"
      ) as HTMLElement;
      if (teamSupportBody) teamSupportBody.style.display = "none";
    } else {
      let apiKey = "";
      if (dmsType === 0)
        apiKey = process.env.REACT_APP_SNAPENGAGE_API_KEY_IDEAL ?? "";
      else if (dmsType)
        apiKey = process.env.REACT_APP_SNAPENGAGE_API_KEY_INFINITY ?? "";
      getTeamSupportWidgetSnippet(apiKey);
      //Hide the intercom
      interval = setInterval(() => {
        let intercormWidgetLauncher = document.getElementsByClassName(
          "intercom-launcher"
        )[0] as HTMLElement;
        let intercormWidgetBody = document.getElementsByClassName(
          "intercom-app"
        )[0] as HTMLElement;
        if (intercormWidgetLauncher) {
          intercormWidgetLauncher.style.display = "none";
          //clearInterval(interval);
        } else if (intercormWidgetBody) {
          intercormWidgetBody.style.display = "none";
          //clearInterval(interval);
        }
      }, 100);
    }

    return () => {
      clearInterval(interval);
      //Hide the team support if already open
      let teamSupportWidget = document.getElementById(
        "designstudio-button"
      ) as HTMLElement;
      if (teamSupportWidget) teamSupportWidget.style.display = "none";
      let teamSupportBody = document.getElementById(
        "designstudio"
      ) as HTMLElement;
      if (teamSupportBody) teamSupportBody.style.display = "none";
      //Again show back the intercom
      let intercormWidgetLauncher = document.getElementsByClassName(
        "intercom-launcher"
      )[0] as HTMLElement;
      if (intercormWidgetLauncher)
        intercormWidgetLauncher.style.display = "unset";
      let intercormWidgetBody = document.getElementsByClassName(
        "intercom-app"
      )[0] as HTMLElement;
      if (intercormWidgetBody) intercormWidgetBody.style.display = "unset";
    };
  }, [dmsType]);

  return (
    <>
      <CssBaseline />
      <AppTopbar></AppTopbar>
      <AppLeftMenu />
      <Main>
        <DrawerHeader />
        <AppRoutes />
      </Main>
      <SnackBarPopup
        severity="success"
        message="Sync Complete!"
        onClose={() => {
          setShowSyncAlert(false);
          dispatch(setIsSyncCompleted({ status: false }));
        }}
        open={showSyncAlert}
        autoHideDuration={null}
      ></SnackBarPopup>
    </>
  );
};
